import { Injectable, inject } from '@angular/core';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { IOpenGraphService } from 'projects/suche-lib/src/lib/services/open-graph.service';
import { CanonicalUrlService } from './canonical-url.service';

/**
 * Setzt dynamische meta Tags nach dem Open Graph Protocol. Trägt zur besseren Darstellung beim Teilen in sozialen Netzewerken bei.
 * Wird nur über das AppModule (nicht {providedIn: 'root'}) provided und in der library über ein InjectionToken immer als Optional
 * Dependency injected. Das gewährleistet, dass die library auch ohne Open Graph Protocol verwendet werden kann (z.B. bei SET-E).
 * https://ogp.me/
 */
@Injectable()
export class OpenGraphService implements IOpenGraphService {
  private readonly metaService = inject(Meta);
  private readonly title = inject(Title);
  private readonly canonicalUrlService = inject(CanonicalUrlService);

  constructor() {
    this.metaService.updateTag({ property: 'twitter:domain', content: location.host });
  }

  setDescription(description: string): void {
    this.update(description);
  }

  private update(description?: string): void {
    this.canonicalUrlService.getCanonicalUrl().then((content) => {
      let tags: MetaDefinition[] = [
        { property: 'og:title', content: this.title.getTitle() },
        { property: 'twitter:title', content: this.title.getTitle() },
        { property: 'og:url', content },
        { property: 'twitter:url', content }
      ];
      if (!!description) {
        tags = tags.concat([
          { name: 'description', content: description },
          { property: 'og:description', content: description },
          { property: 'twitter:description', content: description }
        ]);
      }
      tags.forEach((tag) => this.metaService.updateTag(tag));
    });
  }
}
